import {
    AppClockService,
    createFakeNewRelicReporterService,
    createNewRelicReporterService as createService,
    isNewRelicReporterActive,
    NewRelicReporterServiceOptions,
    NullableNewRelicReporterConfig,
} from '@mews/framework';

export interface PrepareNewRelicReporterServiceParams
    extends Pick<NewRelicReporterServiceOptions, 'sentryReporterService'> {
    appClockService: AppClockService;
    newRelicReporterConfig: NullableNewRelicReporterConfig;
}

export const createNewRelicReporterService = ({
    appClockService,
    newRelicReporterConfig,
    sentryReporterService,
}: PrepareNewRelicReporterServiceParams) =>
    isNewRelicReporterActive(newRelicReporterConfig)
        ? createService({
              apiEndpoint: newRelicReporterConfig.eventEndpoint,
              apiInsertKey: newRelicReporterConfig.insertKey,
              getTimestamp: appClockService.getValue,
              sentryReporterService,
          })
        : createFakeNewRelicReporterService();
